import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchHelpServices,
  fetchHelpServicesSuccess,
  fetchHelpServicesFailure,
} from "../slices/helpServiceSlice";

const API_BASE_URL = process.env.REACT_APP_API_URL;

function* fetchHelpServicesWorker() {
  try {
    const response = yield call(fetch, `${API_BASE_URL}/v1/help-services`);
    const result = yield response.json();

    yield put(fetchHelpServicesSuccess(result.data));
  } catch (error) {
    yield put(fetchHelpServicesFailure("Failed to load services"));
  }
}

export function* watchHelpServices() {
  yield takeLatest(fetchHelpServices.type, fetchHelpServicesWorker);
}
